export const numUtils = {
    commaSperate: (number: string | number) => number != null ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','): '',
}
